var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5992 17.1996C25.5992 19.1878 23.9874 20.7996 21.9992 20.7996C20.011 20.7996 18.3992 19.1878 18.3992 17.1996C18.3992 15.2114 20.011 13.5996 21.9992 13.5996C23.9874 13.5996 25.5992 15.2114 25.5992 17.1996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5992 19.5996C31.5992 20.9251 30.5247 21.9996 29.1992 21.9996C27.8737 21.9996 26.7992 20.9251 26.7992 19.5996C26.7992 18.2741 27.8737 17.1996 29.1992 17.1996C30.5247 17.1996 31.5992 18.2741 31.5992 19.5996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7992 27.9996C26.7992 25.3486 24.6502 23.1996 21.9992 23.1996C19.3483 23.1996 17.1992 25.3486 17.1992 27.9996V31.5996H26.7992V27.9996Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1992 19.5996C17.1992 20.9251 16.1247 21.9996 14.7992 21.9996C13.4737 21.9996 12.3992 20.9251 12.3992 19.5996C12.3992 18.2741 13.4737 17.1996 14.7992 17.1996C16.1247 17.1996 17.1992 18.2741 17.1992 19.5996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1992 31.5996V27.9996C29.1992 26.7346 28.873 25.5459 28.3001 24.5128C28.5875 24.4389 28.8888 24.3996 29.1992 24.3996C31.1874 24.3996 32.7992 26.0114 32.7992 27.9996V31.5996H29.1992Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6983 24.5128C15.1254 25.5459 14.7992 26.7346 14.7992 27.9996V31.5996H11.1992V27.9996C11.1992 26.0114 12.811 24.3996 14.7992 24.3996C15.1097 24.3996 15.4109 24.4389 15.6983 24.5128Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerActive);
export default __webpack_public_path__ + "static/media/customer-active.07aa43beabc445a993022ea1a37d610d.svg";
export { ForwardRef as ReactComponent };